import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";

import { type ATeamWorkplaces } from "../types";
import { useATeamStatus } from "../useATeamStatus";
import { FacilityCard } from "./card/FacilityCard";
import { FacilityCardGhost } from "./card/FacilityCard.ghost";

interface ATeamListProps {
  workplaces: ATeamWorkplaces;
  isLoading: boolean;
}

function BottomText(props: ATeamListProps) {
  const { workplaces, isLoading } = props;

  if (isLoading) {
    return null;
  }

  const isATeamWorkplaceExists = Object.keys(workplaces).length > 0;

  if (isATeamWorkplaceExists) {
    return null;
  }

  return (
    <Stack direction="row" justifyContent="center" alignItems="center">
      <Text variant="body1">
        You don&apos;t have Priority Plus because no workplaces have selected you to be a part of
        their A-Team. Going forward, Priority Access will be given to you automatically by having a
        high Clipboard Score and by working at the facility frequently!
      </Text>
    </Stack>
  );
}

export function ATeamList(props: ATeamListProps) {
  const { workplaces, isLoading } = props;
  const { isATeamOffExperimentEnabled } = useATeamStatus();

  return (
    <Stack gap={isDefined(workplaces) && Object.keys(workplaces).length > 0 ? 3 : 1}>
      <Text
        variant="h2"
        sx={{
          color: "#424242",
          fontSize: "18px",
          fontWeight: "600",
        }}
      >
        Priority Plus Workplaces
      </Text>
      {Object.values(workplaces)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((workplace) => (
          <FacilityCard
            key={workplace.id}
            facilityId={workplace.id}
            facilityName={workplace.name}
            aTeamRosterSize={workplace.aTeamRosterSize}
          />
        ))}
      {!isATeamOffExperimentEnabled && <BottomText workplaces={workplaces} isLoading={isLoading} />}
      {isLoading &&
        Array.from({ length: 5 })
          .fill(undefined)
          // eslint-disable-next-line react/no-array-index-key
          .map((_, index) => <FacilityCardGhost key={index} />)}
    </Stack>
  );
}
